<template>
<div id="playerbar">
  <div class="mini-player" v-show="!fullScreen" @click="open">

    <!-- <audio class="header-tips-audio" :src="newContent.mediaurl" controls="controls" controlsList="nodownload" oncontextmenu="return false" v-if="newContent.mediaurl" style="border:1px solid red;">
    您的浏览器不支持 audio 标签。
    </audio> -->

    <div class="icon">
      <img alt="" src="//p0.ifengimg.com/pmop/2017/1106/93B9FC60B54079B13D734CADA5E7F7414E7FB626_size43_w468_h563.jpeg" width="40" height="40" :class="cdCls">
    </div>
    <div class="text">
      <h2 class="name" >他为华人在国外赢了个重要官司 西方媒体却不敢报</h2>
      <p class="desc" >test1</p>
    </div>
    <div class="control">
      <!--阻止冒泡-->
      <!-- <progress-circle :radius="radius" :percent="percent">
        <i @click.stop="togglePlaying" class="icon-mini" :class="miniIcon"></i>
      </progress-circle> -->
    </div>
    <div class="control" @click.stop="showPlayList">
      <i class="icon-playlist"></i>
    </div>
  </div>
</div>
</template>
<script>
import '../../static/style/common/playerbar.scss'
import {mapGetters, mapActions} from 'vuex';

export default {
    model: {
      prop: ['currentSong'],
    },
    props: {
      newsdata: Array,
      labelname: String,
      tipshow: Boolean,
      goUrl: Function,
      limit: Number,
      total: Number,
      handlePageChange: Function,
      urladdr: String,
    },
    data: () => ({
      fullScreen: false,

    }),
    created() {
        console.debug("created> currentSong:%o", this.currentSong);
    },
    mounted() {
        // console.debug("mounted> handlePageChange:%o", this.handlePageChange);
    },
    computed: {
        ...mapGetters({
            // 映射 this.getLoadingStatus 为 store.getters.getLoadingStatus
        })
    },
    methods: {
        ...mapActions({
          // 映射 this.updateLoadingStatus() 为 this.$store.dispatch('updateLoadingStatus')
        }),
        open() {},
        cdCls() {},
        showPlayList() {},
        ready() {},
        error() {},
        updateTime() {},
        ended() {},
    }
}
</script>



// WEBPACK FOOTER //
// playerbar.vue?2f8a32fe